// @ts-nocheck
import { Box, Drawer } from '@mui/material';
import { DotsSixVertical, X } from '@phosphor-icons/react';
import { Draggable, Droppable } from 'react-beautiful-dnd';
import { useTranslation } from 'react-i18next';
import { XGInput } from 'xg-cl';
import { getPassengerFieldTypeLabel } from '../../../utils/passengerFieldTypes';
import * as PropTypes from 'prop-types';

const CollectionLibraryDrawer = ({
  isOpen,
  isMounted,
  droppableId,
  fieldDroppableType,
  fields = [],
  searchInputId,
  searchValue,
  onSearchChange,
  onClose,
  isFieldDisabled,
  getFieldKey,
  getDraggableId,
  getUsageBadgeLabel,
  getUsageBadgeVariant
}) => {
  const { t } = useTranslation(['settings', 'passengers']);
  const isTripPassengerFields = fields?.some(
    (field) => field?.trippassengerfieldid
  );

  return (
    <Drawer
      hideBackdrop
      open={isOpen}
      onClose={onClose}
      PaperProps={{
        className: 'passenger-collection-panel__library-paper'
      }}
      className={`passenger-collection-panel__library-drawer ${isTripPassengerFields ? 'trip__passenger-collection-panel__library-drawer ' : ''} ${isOpen ? 'drawer-open' : ''}`}
      anchor={'right'}
      id='trip-passenger-fields-slideout-drawer'
      position='right'
    >
      <Box className='passenger-collection-panel__library'>
        <Box className='passenger-collection-panel__library-header'>
          <span className='passenger-collection-panel__library-title'>
            {t('fieldLibrary')}
          </span>
          <button
            type='button'
            className='passenger-collection-panel__library-close'
            onClick={onClose}
          >
            <X size={18} />
          </button>
        </Box>

        <Box className='passenger-collection-panel__library-search'>
          <XGInput
            id={searchInputId}
            label={null}
            name={searchInputId}
            placeholder={t('searchFieldLibrary')}
            type='text'
            value={searchValue}
            onChange={(event) => onSearchChange(event?.target?.value ?? '')}
          />
        </Box>

        {isMounted && (
          <Droppable
            droppableId={droppableId}
            type={fieldDroppableType}
            isDropDisabled={true}
          >
            {(provided) => (
              <Box
                className='passenger-collection-panel__library-list'
                ref={provided.innerRef}
                {...provided.droppableProps}
              >
                {fields.length === 0 ? (
                  <Box className='passenger-collection-panel__library-empty'>
                    {t('noPassengerFieldsFound')}
                  </Box>
                ) : (
                  fields.map((field, index) => {
                    const disabled = isFieldDisabled(field);
                    const fieldKey = getFieldKey(field);
                    const usageBadgeLabel = getUsageBadgeLabel(field);

                    return (
                      <Draggable
                        key={fieldKey}
                        draggableId={getDraggableId(field)}
                        index={index}
                        isDragDisabled={disabled}
                      >
                        {(draggableProvided) => (
                          <Box
                            ref={draggableProvided.innerRef}
                            {...draggableProvided.draggableProps}
                            {...draggableProvided.dragHandleProps}
                            className={`passenger-collection-panel__library-item ${
                              disabled
                                ? 'passenger-collection-panel__library-item--disabled'
                                : 'passenger-collection-panel__library-item--draggable'
                            }`}
                          >
                            <Box
                              className={`passenger-collection-panel__drag-handle passenger-collection-panel__library-handle ${
                                disabled
                                  ? 'passenger-collection-panel__drag-handle--static'
                                  : 'passenger-collection-panel__drag-handle--enabled'
                              }`}
                            >
                              <DotsSixVertical size={16} />
                            </Box>

                            <Box className='passenger-collection-panel__library-copy'>
                              <span className='passenger-collection-panel__library-item-title'>
                                {field?.title}
                              </span>
                              <span className='passenger-collection-panel__library-item-subtitle'>
                                {getPassengerFieldTypeLabel(
                                  field?.fieldtype,
                                  t
                                )}
                              </span>
                              {usageBadgeLabel && (
                                <span
                                  className={`passenger-collection-panel__library-item-badge passenger-collection-panel__library-item-badge--${getUsageBadgeVariant(field)}`}
                                >
                                  {usageBadgeLabel}
                                </span>
                              )}
                            </Box>
                          </Box>
                        )}
                      </Draggable>
                    );
                  })
                )}
                {provided.placeholder}
              </Box>
            )}
          </Droppable>
        )}
      </Box>
    </Drawer>
  );
};

CollectionLibraryDrawer.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  isMounted: PropTypes.bool.isRequired,
  droppableId: PropTypes.string.isRequired,
  fieldDroppableType: PropTypes.string.isRequired,
  fields: PropTypes.array,
  searchInputId: PropTypes.string.isRequired,
  searchValue: PropTypes.string.isRequired,
  onSearchChange: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  isFieldDisabled: PropTypes.func.isRequired,
  getFieldKey: PropTypes.func.isRequired,
  getDraggableId: PropTypes.func.isRequired,
  getUsageBadgeLabel: PropTypes.func.isRequired,
  getUsageBadgeVariant: PropTypes.func.isRequired
};

export default CollectionLibraryDrawer;
